<template>
  <div style="overflow: hidden">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="事 件" name="first" style="overflow: auto">


        <!--        1：数据提交前进行验证某个值-->


        <div style="background-color: #efefef;padding:10px">
          提交前事件
          <el-switch
            v-model="from.submission"
            @change="updatesubmission"
            active-color="#13ce66"
          >
          </el-switch>


        </div>
        <div style="background-color: #efefef;padding:10px;margin-top: 5px">
          提交后事件
          <el-switch
            v-model="from.submend"
            @change="updatesubmend"
            active-color="#13ce66"
          >
          </el-switch>
          <br>
          <div v-if="from.submend">


            <div style="background-color: #FFFFFF;padding:20px" v-for="(item,index) in from.submissionevent">


              <el-button type="text" size="mini" @click="from.submissionevent.splice(index,1)">删除事件</el-button>


              <div>
                事件操作：
                <el-radio-group v-model="item.addtype">
                  <el-radio :label="0">修改表单数据</el-radio>
                  <el-radio :label="1">添加表单数据</el-radio>
                </el-radio-group>

              </div>

              <br>
              <div>

                <b>目标数据表单</b>
                <el-select size="mini" value-key="_id" @change="getortable(item)" clearable v-model="item.server" placeholder="请选择">
                  <el-option
                    v-for="item2 in serverlist"
                    :key="item2._id"
                    :label="item2.name"
                    :value="{name:item2.name,_id:item2._id,module:item2.module,server:item2.server}">
                  </el-option>
                </el-select>


                <b>条件</b>
                <span v-if="item.addtype==0">
                {{ item.server.name }}表单字段
                <el-select size="mini" value-key="_id" clearable v-model="item.where.target_filed" placeholder="请选择">

                  <el-option
                    v-for="item3 in filedtable[item.server._id]"
                    :key="item3._id"
                    :label="item3.name"
                    :value="{name:item3.name,_id:item3._id,key:item3.key}">
                  </el-option>
                </el-select>

                <b>等于{{ from.name }}字段</b>

                <el-select size="mini" value-key="_id" clearable v-model="item.where.me_table" placeholder="请选择">
                  <el-option
                    v-for="item3 in mefield"
                    :key="item3._id"
                    :label="item3.name"
                    :value="{name:item3.name,_id:item3._id,key:item3.key}">
                  </el-option>
                </el-select>

                  <el-checkbox v-model="item.upinsert">有则修改无则添加</el-checkbox>

                </span>


              </div>
              <el-button type="text" size="mini" @click="add_subeventfiled(item)">添加字段</el-button>
              <div v-for="(item2,index2) in item.field" :key="index2" style="margin-top: 5px;">
                <b> {{ item.server.name }}表单字段</b>
                <el-select size="mini" value-key="_id" clearable v-model="item2.target_filed" placeholder="请选择">
                  <el-option
                    v-for="item3 in filedtable[item.server._id]"
                    :key="item3._id"
                    :label="item3.name"
                    :value="{name:item3.name,_id:item3._id,key:item3.key}">
                  </el-option>
                </el-select>

                <b>数据来源</b>

                <el-radio-group v-model="item2.valuetype">
                  <el-radio :label="0">固定值</el-radio>
                  <el-radio :label="1">字段</el-radio>
                  <el-radio :label="3">编号</el-radio>
                </el-radio-group>

                <el-input v-if="item2.valuetype==0" v-model="item2.value" size="mini" style="width: 200px"></el-input>

                <el-select v-else-if="item2.valuetype==1" size="mini" value-key="_id" clearable v-model="item2.me_table" placeholder="请选择">
                  <el-option
                    v-for="item3 in mefield"
                    :key="item3._id"
                    :label="item3.name"
                    :value="{name:item3.name,_id:item3._id,key:item3.key,type:item3.type}">
                  </el-option>
                </el-select>
                <b>操作</b>
                <el-select size="mini" value-key="value" clearable v-model="item2.event" placeholder="请选择">
                  <el-option :value="{label:'替换',value:0}" label="替换"> 替换</el-option>
                  <el-option v-if="item2.valuetype==1 && item2.me_table.type=='number'" :value="{label:'求和',value:1}" label="求和"> 求和</el-option>
                  <el-option v-if="item2.valuetype==1 && item2.me_table.type=='number'" :value="{label:'求差',value:2}" label="求差"> 求差</el-option>
                </el-select>
                <el-button type="text" size="mini" @click="item.field.splice(index2,1)">删除字段</el-button>


              </div>


            </div>

            <div style="text-align: center">
              <br>
              <el-button type="text" size="mini" @click="add_subevent">添加事件</el-button>
            </div>


          </div>

        </div>


        <div style="text-align: center" v-if="activeName=='first'">
          <br>
          <el-button type="primary" style="width: 100px" size="mini" @click="saveent">保 存</el-button>
        </div>
        <!--        2：数据提交完后触发事件-->
      </el-tab-pane>

    </el-tabs>

    <div style="text-align: center" v-if="activeName=='second'">
      <br>

      <el-button type="primary" style="width: 100px" size="mini" @click="favefloow">保 存</el-button>
    </div>
  </div>
</template>


<script>

import u from "../../../assets/js/util.js";

export default {
  props: ["from"],
  components: {},
  name: "event_edit",
  data() {
    return {
      activeName: 'first',
      updateData: {},
      serverlist: [],
      showfield: [],
      mefield: [],
      filedtable: {}
    };
  },
  async mounted() {
    this.serverlist = await u.post("admin", "menu_v2query", {})
    this.mefield = await u.post("admin", "query_filed", {menu_id: this.from._id})


    if (this.from.submissionevent) {
      var list = this.from.submissionevent

      for (var i = 0; i < list.length; i ++) {
        if (list[i].server._id) {
          this.filedtable[list[i].server._id] = await u.post("admin", "query_filed", {menu_id: list[i].server._id})
        }
      }
      this.$forceUpdate()

    }
  },
  methods: {
    async getortable(e) {

      e.field = []

      if (e.server._id) {
        this.filedtable[e.server._id] = await u.post("admin", "query_filed", {menu_id: e.server._id})
      }
      this.$forceUpdate()
    },
    add_subeventfiled(item) {


      var field = {
        target_filed: {
          key: "",
          _id: "",
          type: "",
          name: ""
        },
        me_table: {
          key: "",
          _id: "",
          type: "",
          name: ""
        },
        valuetype: 0,
        value: "",
        event: {}

      }

      item.field.push(field)
    },
    add_subevent() {

      var from = this.from

      if (!from.submissionevent) {
        from.submissionevent = []
      }
      var event = {
        upinsert: false,
        server: {
          type: "",
          name: "",
          server: "",
          module: "",
          _id: ""
        },
        where: {
          target_filed: {
            key: "",
            _id: "",
            type: "",
            name: ""
          },
          me_table: {
            key: "",
            type: "",
            _id: "",
            name: ""
          },
        },
        field: []
      }

      from.submissionevent.push(event)

      this.$forceUpdate()


    },
    async updatemove(e) {
      this.from.floowstatus = e

    },
    async updatesubmission(e) {
      this.from.submission = e
      // await u.post("admin", "menu_v2", this.from,true)
    },
    async updatesubmend(e) {
      this.from.submend = e
      // await u.post("admin", "menu_v2", this.from,true)
    },
    async sublimtfloow(e) {
      var floow = {
        tab_name: this.from.name,
        tab_id: this.from._id,
        temp: e.list,
        module: this.from.module,
        _id: e._id
      }

      var res = await u.post("floow", "floow/add", floow)

      if (res !== false) {
        u.alert("保存成功")
        this.$emit("success", "")
      }

    },
    async saveent() {


      // var submissionevent = this.from.submissionevent


      var res = await u.post("admin", "menu_v2", this.from)

      if (res !== false) {
        u.alert("保存成功")
        this.$emit("success", "")
      }

    },
    async favefloow() {
      try {
        await u.post("admin", "menu_v2", this.from, true)
        this.$refs['floow'].save()
      } catch (e) {
        this.$emit("success", "")
      }
    },
  }
};
</script>
<style scoped>


/deep/ .el-tabs__nav-scroll {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

/deep/ .el-tabs__item {
  font-size: 26px;
}

/deep/ .el-tab-pane {
  height: 740px;
}

/deep/ .el-dialog {
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/page/module/admin/event_edit.vue